import './VideoEdu_stu_detail_mission.scss';
import * as S from '../scss/theme';
import fnc from '../mymod/commFunction';
import fncS4 from '../mymod/commFunction4';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import HongButton from '../comm/HongButton';
import HeaderTitle from '../comm/HeaderTitle';
import imgYoutube from '../images/svg/youtube.svg';
import VideoPlayer from '../video/VideoPlayer';
import HongAudioPlayer from '../audio/HongAudioPlayer';

const VideoEdu_stu_detail_mission = ({selectedCode, setIsRefreshParent}) => {
  const S3_URL = process.env.REACT_APP_S3_URL_LOCAL;
  const selectedUserInfo = useSelector((state) => state.reduxIgong.selectedUserInfo);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [list, setList] = useState([]);
  const [kind, setKind] = useState(null);
  const [mission, setMission] = useState('');
  const [content, setContent] = useState('');
  const [isRefresh, setIsRefresh] = useState(false);
  const [audioSrc, setAudioSrc] = useState('');
  const [isAutoPlay, setIsAutoPlay] = useState(false);

  useEffect(() => {

    if (selectedCode) {
        const pCode = selectedCode;
        const stCode = selectedUserInfo.stCode;

        fncSelect_list(selectedCode);
        fncSelect_list_content(pCode, stCode)
    }
  }, [isRefresh]);


  useEffect(() => {
    if (list.length > 0) {
      const mission = list[0].mission || '';
      setMission(mission);
    }
  }, [list]);


 async function fncPlayMp3(mp3FileName) {
    if (mp3FileName) {    
      const fullPath = await fncS4.getS3PathLong( `mp3/mission/${mp3FileName}`);//`mp3/feedback/bd_1-1.mp3`
      // const fullPath = `${S3_URL}/mp3/mission/${mp3FileName}`;
      setAudioSrc(fullPath);
      setIsAutoPlay(true);
    }   
  } 
  
  
  function fncSelect_list(code) {
    fnc.sendAxios('/videoEduRoutes/select/video_eduProgram_mission_unit2_mission', { code }, (res) => {
      if (res && Array.isArray(res)) {
        const newList = getRecords(res);
        setList(newList);

        const mp3FileName = res[0].mp3_mission;
        fncPlayMp3(mp3FileName);

      } else {
        alert('검색에 실패했습니다.');
      }
    });
  
    function getRecords(res) {
      const records = [];
      res.forEach(item => {
      const sno = item["sno"];
      const no = item["no"];
      const pCode = item["pCode"];
      const code = item["code"];
      const title1 = item["title1"];
      const title2 = item["title2"];
      const url = item["url"];
      const mission = item["mission"];
      // const feedBack = item["feedBack"];
        records.push({ sno, no, pCode, code, title1, title2, url, kind, mission });
      });
      return records;
    }
  }


  function fncSelect_list_content(pCode, stCode) {
    fnc.sendAxios('/videoEduRoutes/select/video_eduProgram_mission_answer', { pCode, stCode }, (res) => {
      if (Array.isArray(res) && res.length > 0) {
        setContent(res[0].answer);
      } else {
        setContent('');
      }
    });
  }

  function onSave() {
    const rtn = window.confirm(`답변을 저장하시겠습니까?`);
    if (!rtn) return;

    const pCode = selectedCode;
    const stCode = selectedUserInfo.stCode;
    const userName = selectedUserInfo.userName;
    const userKind = selectedUserInfo.userKind;
    const eDate = fnc.fncDate();
    const answer = content;

    fnc.sendAxios('/videoEduRoutes/insert/video_eduProgram_mission_answer', { 
        pCode, stCode, userName, userKind, answer, eDate }, (res) => {

        if (res && res.success) {
            alert('완료되었습니다.');
            onRefresh();
            setIsRefreshParent(true);

        } else {
           alert('실패했습니다.');
        }
        
    });
  
  }

  function onDelete() {
    const rtn = window.confirm(`답변을 삭제하시겠습니까?`);
    if (!rtn) return;

    const pCode = selectedCode;
    const stCode = selectedUserInfo.stCode;

    fnc.sendAxios('/videoEduRoutes/delete/video_eduProgram_mission_answer', { 
        pCode, stCode }, (res) => {

        if (res && res.success) {
            alert('완료되었습니다.');
            onRefresh();
        } else {
           alert('실패했습니다.');
        }
        
    });

  }

  function onRefresh() {
    setIsRefresh(!isRefresh);
  }

  
  
//=========================================
  return (
  // <S.Section>
  <div>
     {/* <HeaderTitle  title={title + '의 진단 리스트'} direction={1} onBackClick={() => navigate(-1)} /> */}
    <div className='VideoEdu_stu_detail_mission'>
      <section className='sec-main'>

      <div className='box-que'>
        <div className='txt-content'>
          {mission}
        </div>
      </div>

      <div className='box-audio'>
        <HongAudioPlayer 
              audioSrc={audioSrc} 
              autoPlay={isAutoPlay} 
              onPlayCallback={() => console.log("Dynamic audio played")} 
          />
      </div>
                   
      <div className='box-textArea'>
          <textarea 
              name="postContent" 
              id="postContent" 
              rows="10" 
              cols="50"
              placeholder="여기에 답변을 작성하세요..."    
              value={content}       
              onChange={(event) => setContent(event.target.value)}     
          ></textarea>
      </div>

      
        


      </section> 

      <div className='box-menu'>
          <HongButton className='btn h-btn-gray' onClick={onRefresh} disableTime={5}>새로고침</HongButton>
          <HongButton className='btn h-btn-red' onClick={onSave}>저장하기</HongButton>
          <HongButton className='btn h-btn-sky' onClick={onDelete} >삭제하기</HongButton>
      </div>

    </div>


   

 
  {/* </S.Section> */}

     </div>
  );
};

export default VideoEdu_stu_detail_mission;